// Fecha de corte para el histórico de Estado de Cuenta. Toda data anterior
// se considera cubierta por el saldo inicial cargado por entidad.
export const FECHA_CORTE = "2026-01-01";

// Construye la entry sintética de saldo inicial al 01/01/2026.
// monto > 0 → débito (la entidad nos debe); monto < 0 → crédito (le debemos).
// monedaPrincipal se usa como fallback cuando el saldo no trae moneda explícita.
//
// Nota: NO pre-convierte a display — devuelve la entry en moneda nativa para
// que el loop del ledger aplique toDisplayCurrency uniformemente sobre todas
// las entries (sin doble conversión).
export const buildSaldoInicialEntry = (saldoInicial, monedaPrincipal) => {
  const monto = Number(saldoInicial.monto || 0);
  return {
    fecha: FECHA_CORTE,
    concepto: "Saldo inicial al 01/01/2026",
    origen: "INI",
    referencia: saldoInicial.notas || "",
    debito: monto > 0 ? monto : 0,
    credito: monto < 0 ? -monto : 0,
    moneda: saldoInicial.moneda || monedaPrincipal,
  };
};

// Busca el saldo inicial registrado para una entidad concreta. Devuelve null
// para selecciones no-numéricas ("todos", "alianza:X", "") porque el saldo
// inicial solo aplica a entidades individuales.
export const encontrarSaldoInicial = (saldosIniciales, entidadTipo, entidadId) => {
  if (!entidadId) return null;
  const id = Number(entidadId);
  if (!Number.isFinite(id)) return null;
  return saldosIniciales.find((s) => s.entidad_tipo === entidadTipo && s.entidad_id === id) || null;
};
